// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getLocator } from '@tcp/core/src/utils';
import { BadgeContainer, BadgeText } from './styles/ZoneOneBadges.style';

const ZoneOneBadges = (props) => {
  const { type, className, text } = props;
  return (
    <BadgeContainer className={className} type={type}>
      <BadgeText
        dataLocator={getLocator('global_productbadge_txt')}
        fontFamily="secondary"
        fontSize="fs8"
        fontWeight="extrabold"
        className="zone-one-badge-label"
        type={type}
      >
        {text}
      </BadgeText>
    </BadgeContainer>
  );
};

ZoneOneBadges.defaultProps = {
  type: '',
  className: '',
};

ZoneOneBadges.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default ZoneOneBadges;
